import apiClients from "@/services/api.clients";

const state = {
    clients: [],
    clientCopy: {},
    sizeStatusClients: {},
    isLoadingGetClients: false,
    IsLoadingClientCopy: false,
    isLoadingShareClient: false,
    isLoadingTransferToClient: false,
    isLoadingDeleteClient: false,
    isLoadingLastContactClient: false
}

export const mutationTypes = {
    findClientsStart: '[clients] Find  clients start',
    findClientsSuccess: '[clients] Find  clients success',
    findClientsFailure: '[clients] Find  clients failure',

    clientCopyStart: '[clients] Client copy start',
    clientCopySuccess: '[clients] Client copy success',
    clientCopyFailure: '[clients] Client copy failure',

    shareClientStart: '[clients] Share client start',
    shareClientSuccess: '[clients] Share client success',
    shareClientFailure: '[clients] Share client failure',

    transferToClientStart: '[clients] Transfer to Client start',
    transferToClientSuccess: '[clients] Transfer to Client success',
    transferToClientFailure: '[clients] Transfer to Client failure',

    deleteClientStart: '[clients] Delete client start',
    deleteClientSuccess: '[clients] Delete client success',
    deleteClientFailure: '[clients] Delete client failure',

    lastContactClientStart: '[clients] Last contact client start',
    lastContactClientSuccess: '[clients] Last contact client success',
    lastContactClientFailure: '[clients] Last contact client failure',

}

export const actionTypes = {
    getClients: '[clients] Get clients',
    clientCopy: '[clients] Client copy',
    shareClient: '[clients] Share client',
    transferToClient: '[clients] Transfer to client',
    deleteClient: '[clients] Delete client',
    lastContactClient: '[clients] Last contact client'
}

export const getterTypes = {
    clients: '[clients] Clients',
    isLoadingGetClients: '[clients] Is loading get clients',
    sizeStatusClients: '[clients] Size status clients',
    IsLoadingClientCopy:  '[clients] Is loading client copy',
    isLoadingShareClient: '[clients] Is loading share client',
    isLoadingTransferToClient: '[clients] Is loading transfer to client',
    isLoadingDeleteClient: '[clients] Is loading delete client',
    isLoadingLastContactClient: '[clients] Is loading last contact client'
}

const getters = {
    [getterTypes.clients]: (state) => {
        return state.clients
    },
    [getterTypes.isLoadingGetClients]: (state) => {
        return state.isLoadingGetClients
    },
    [getterTypes.sizeStatusClients]: (state) => {
        return state.sizeStatusClients
    },
    [getterTypes.IsLoadingClientCopy]: (state) => {
        return state.IsLoadingClientCopy
    },
    [getterTypes.isLoadingShareClient]: (state) => {
        return state.isLoadingShareClient
    },
    [getterTypes.isLoadingTransferToClient]: (state) => {
        return state.isLoadingTransferToClient
    },
    [getterTypes.isLoadingDeleteClient]: (state) => {
        return state.isLoadingDeleteClient
    },
    [getterTypes.isLoadingLastContactClient]: (state) => {
        return state.isLoadingLastContactClient
    }
}
const mutations = {
    [mutationTypes.findClientsStart](state) {
        state.isLoadingGetClients = true
    },
    [mutationTypes.findClientsSuccess](state, payload) {
        state.sizeStatusClients = payload.counts
        state.clients = payload.clients.map(i => {
            let newClients = Object.assign({isStatusSelect: false, menu: false}, i)
            return newClients
        })
        state.isLoadingGetClients = false
    },
    [mutationTypes.findClientsFailure](state) {
        state.isLoadingGetClients = false
    },
    [mutationTypes.clientCopyStart] (state) {
        state.IsLoadingClientCopy = true
    },
    [mutationTypes.clientCopySuccess](state, clientCopy) {
        state.clientCopy = clientCopy
        state.IsLoadingClientCopy = false
    },
    [mutationTypes.shareClientStart](state) {
        state.isLoadingShareClient = true
    },
    [mutationTypes.shareClientSuccess](state){
        state.isLoadingShareClient = false
    },
    [mutationTypes.shareClientFailure](state){
        state.isLoadingShareClient = false
    },
    [mutationTypes.transferToClientStart](state){
        state.isLoadingTransferToClient = true
    },
    [mutationTypes.transferToClientSuccess](state){
        state.isLoadingTransferToClient = false
    },
    [mutationTypes.transferToClientFailure](state) {
        state.isLoadingTransferToClient = false
    },
    [mutationTypes.deleteClientStart](state) {
        state.isLoadingDeleteClient = true
    },
    [mutationTypes.deleteClientSuccess](state) {
        state.isLoadingDeleteClient = false
    },
    [mutationTypes.deleteClientFailure](state){
        state.isLoadingDeleteClient = false
    },
    [mutationTypes.lastContactClientStart](state){
        state.isLoadingLastContactClient = true
    },
    [mutationTypes.lastContactClientSuccess](state){
        state.isLoadingLastContactClient = false
    },
    [mutationTypes.lastContactClientFailure](state){
        state.isLoadingLastContactClient = false
    }
}
const actions = {
    [actionTypes.getClients](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.findClientsStart)
            apiClients
                .getClients(payload)
                .then(response => {
                    context.commit(mutationTypes.findClientsSuccess, response.data)
                    resolve(response)
                })
                .catch(error => {
                    context.commit(mutationTypes.findClientsFailure)
                    reject(error)
                })
        })
    },
    [actionTypes.clientCopy](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.clientCopyStart)
            apiClients
                .clientCopy(payload)
                .then(response => {
                    context.commit(mutationTypes.clientCopySuccess, response.data)
                    resolve(response)
                })
                .catch(error => {
                    context.commit(mutationTypes.clientCopyFailure)
                    reject(error)
                })
        })
    },
    [actionTypes.shareClient](context, payload){
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.shareClientStart)
            apiClients
                .shareClient(payload)
                .then(response => {
                    context.commit(mutationTypes.shareClientSuccess)
                    resolve(response)
                })
                .catch(error => {
                    context.commit(mutationTypes.shareClientFailure)
                    reject(error)
                })
        })
    },
    [actionTypes.transferToClient](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.transferToClientStart)
            apiClients
                .transferToClient(payload)
                .then(response => {
                    context.commit(mutationTypes.transferToClientSuccess)
                    resolve(response)
                })
                .catch(error => {
                    context.commit(mutationTypes.transferToClientFailure)
                    reject(error)
                })
        })
    },
    [actionTypes.deleteClient](context, payload){
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.deleteClientStart)
            apiClients
                .deleteClient(payload)
                .then(response => {
                    context.commit(mutationTypes.deleteClientSuccess)
                    resolve(response)
                })
                .catch(error => {
                    context.commit(mutationTypes.deleteClientFailure)
                    reject(error)
                })
        })
    },
    [actionTypes.lastContactClient](context, payload) {
        return new Promise((resolve, reject) => {
            context.commit(mutationTypes.lastContactClientStart)
            apiClients
                .lastContactClient(payload)
                .then(response => {
                    context.commit(mutationTypes.lastContactClientSuccess)
                    resolve(response)
                })
                .catch(error => {
                    context.commit(mutationTypes.lastContactClientFailure)
                    reject(error)
                })
        })
    }
}



export default {
    state,
    actions,
    mutations,
    getters,
}
